import { createDynamicThunk } from ".";

export const getUserListThunk = createDynamicThunk({
  typePrefix: "users/getUserListThunk",
  useHandleSearch: true,
});

export const addUserThunk = createDynamicThunk({
  typePrefix: "users/addUserThunk",
  endpoint: "/users",
  method: "POST",
  refreshList: true,
  listThunk: getUserListThunk,
});

export const editUserThunk = createDynamicThunk({
  typePrefix: "users/editUserThunk",
  endpoint: "/users",
  method: "PUT",
  refreshList: true,
  listThunk: getUserListThunk,
  transformResponse: (response) => response,
});

export const deleteUserThunk = createDynamicThunk({
  typePrefix: "/deleteUserThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getUserListThunk,
});

export const getRoleListThunk = createDynamicThunk({
  typePrefix: "roles/getRoleListThunk",
  endpoint: "/roles/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((role) => ({
      label: role?.name,
      value: role?._id,
    })) || [],
});

export const getDiemListThunk = createDynamicThunk({
  typePrefix: "diems/getDiemListThunk",
  endpoint: "/diems/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.filter(
        (diem) => diem?.description !== 'CEO' ).map((diem) => ({
      label: `${diem?.description}`,
      value: diem?._id,
    })) || [],
});

export const getDesignationListThunk = createDynamicThunk({
  typePrefix: "designations/getDesignationListThunk",
  endpoint: "/designations/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((designation) => ({
      label: designation?.name,
      value: designation?.name,
    })) || [],
});

export const getExpenseCatsListThunk = createDynamicThunk({
  typePrefix: "expense-categories/getDesignationListThunk",
  endpoint: "/expense-categories/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((expenseCategory) => ({
      label: expenseCategory?.name,
      value: expenseCategory?._id,
    })) || [],
});